import { vue2 } from 'kometry/adapter/vue2'
import { Console } from 'kometry/providers/console'
import { createTelemetry } from 'kometry/setup'

// eslint-disable-next-line import/prefer-default-export
export const telemetry = createTelemetry({
  appId: 'partner-komerce',
  platform: vue2,
  runtime: 'client',
  environment: process.env.VUE_APP_ENV,
  providers: [
    Console({ level: 'error', runtime: 'client' }),
  ],
})
